export class ResourceFile {
  constructor({
    id = 0,
    category = "",
    section = null,
    label = null,
    href = "",
    type = null,
    ratePlan = null,
    archived = false,
    file = ""
  } = {}) {
    this.id = id;
    this.category = category;
    this.section = section;
    this.label = label;
    this.href = href;
    this.type = type;
    this.ratePlan = ratePlan;
    this.archived = archived;
    this.file = file;
  }
}
export function createResourceFile(data) {
  return Object.freeze(new ResourceFile(data));
}
